import { render, staticRenderFns } from "./UserFolderSelector.vue?vue&type=template&id=43ee961a&scoped=true"
import script from "./UserFolderSelector.vue?vue&type=script&lang=ts"
export * from "./UserFolderSelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ee961a",
  null
  
)

export default component.exports